<template>
  <div class="bothCenter" style="height: 100vh">
    <nut-row>
      <nut-col :span="24">
        <div class="flex-content" v-if="!fastLoginType">
          <img src="https://cdn.waityou.online/c6fcc574-76a6-61c9-7370-daaa05d734e4.svg" style="width: 100px"/>

          <div class="mt64">
            <nut-col :span="24">
              <nut-input
                  class="login-input"
                  v-model="phone"
                  :border="false"
                  placeholder="请输入手机号"/>
            </nut-col>
            <nut-col :span="24">
              <nut-input
                  v-model="smsCode"
                  placeholder="请输入短信验证码"
                  class="login-input"
                  clearable
                  center
              >
                <template #button>
                  <nut-button size="small" type="success"
                              :disabled="second > 0"
                              @click="sendSms">
                    {{ second > 0 ? `${second}s后重试` : '发送验证码' }}
                  </nut-button>
                </template>
              </nut-input>
            </nut-col>
            <nut-col :span="24">
              <nut-button type="success"
                          style="width: 85%;margin-top: 10%" class="loginBtn" @click="login">登录
              </nut-button>
            </nut-col>
          </div>
        </div>
      </nut-col>
    </nut-row>
  </div>
</template>


<script>
import api from "@/api";
import {mapMutations} from "vuex";
import {Toast} from "@nutui/nutui";

export default {
  name: "LoginView",
  data() {
    return {
      phone: '',
      smsCode: '',
      second: 0,
      smsCodeToken: '',
      timer: null,
    }
  },
  methods: {
    ...mapMutations(['updateUser', 'updateEnv']),
    sendSms() {
      if (!this.phone) {
        Toast.fail('请先输入手机号!')
        return
      }
      api.captcha4mobileLogin(this.phone)
          .then(ret => {
            this.smsCodeToken = ret;
            this.second = 60;
            this.timer = setInterval(() => {
              this.second--;
              if (this.second <= 0) {
                clearInterval(this.timer)
              }
            }, 1000)
          })
    },
    login() {
      api.smsLogin({
        verifyToken: this.smsCodeToken.verifyToken,
        captcha: this.smsCode,
      }).then(ret => {
        localStorage.setItem('access_token', ret.accessToken);
        this.$router.replace('/');
        // this.loadUserInfo()
      })
    },
    loadUserInfo() {
      api.getUserInfo().then(userInfo => {
        this.updateUser(userInfo);
        this.updateEnv(this.isWxEnv ? 'wechat' : 'h5');
        // 取到原页面路径
        let url = this.$route.query.redirect;
        // 跳转回原页面
        this.$router.push({
          path: decodeURIComponent(url ? url : '/')
        });
      })
    },
  },
  mounted() {
  }
}
</script>

<style lang="scss" scoped>
.loginBtn {
  font-size: $baseFontSize;
}

.login-input {
  border: 1px solid lightgray;
  width: 80%;
  margin-left: 10%;
  border-radius: 20px;
  padding: 5px 10px;
  margin-bottom: 10px;
  font-size: $baseFontSize;
}

.login-input::placeholder {
  color: grey;
}

.login-input-captcha {
  margin-left: auto;
}

.nut-row {
  overflow: hidden;

  &:not(:last-child) .nut-col {
    margin-bottom: 15px;
  }

  margin-bottom: 15px;
}

.flex-content {
  line-height: 40px;
  text-align: center;
  border: 0;
  font-size: $baseFontSize;
}
</style>